module.exports = __webpack_public_path__ + "static/media/control_entre_carga1.ed7f2571.svg";